export default __webpack_public_path__ + "static/media/Nn.8e07a3e4.wav";